import { memo } from "react";
import { useStages } from "@/context/StagesContext";
import UserDidntAdvanceCard from "@/components/UserDidntAdvanceCard";

const CurrentStageCard = () => {
  const { currentStage, isStageClosed, isUserOutOfReality, isSemiFinalist } =
    useStages();

  if (!currentStage) return null;

  //TODO: remove second condition
  if (isUserOutOfReality || (isStageClosed && isSemiFinalist))
    return <UserDidntAdvanceCard />;

  if (isStageClosed) return null;

  // Stage summary bar removed from UI; stage context still used elsewhere.
  return null;
};

export default memo(CurrentStageCard);
